"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalContext = exports.ModalContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Modal_1 = __importDefault(require("@material-ui/core/Modal"));
var defaultState = {
    open: false,
};
exports.ModalContext = react_1.createContext({ openModal: function () { }, isOpen: false });
var ModalProvider = function (_a) {
    var children = _a.children;
    var _b = react_1.useState(defaultState), modalState = _b[0], setModalState = _b[1];
    var openModal = react_1.useCallback(function (state) { return setModalState(state); }, []);
    var closeModal = function () { return setModalState(defaultState); };
    var Component = modalState.component;
    return (jsx_runtime_1.jsxs(exports.ModalContext.Provider, __assign({ value: { openModal: openModal, isOpen: modalState.open } }, { children: [children,
            jsx_runtime_1.jsx(Modal_1.default, __assign({ open: modalState.open, className: "ds-context-modal" }, modalState.modalProps, { children: jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: Component && jsx_runtime_1.jsx(Component, __assign({ onClose: closeModal }, modalState.componentProps), void 0) }, void 0) }), void 0)] }), void 0));
};
var useModalContext = function () { return react_1.useContext(exports.ModalContext); };
exports.useModalContext = useModalContext;
exports.default = ModalProvider;
